import { ISubjectContact } from "../../../pages/HelpAndSupport/interfaces";

class SubjectContactMapper {
    toPersistence(domainSubjectContact: ISubjectContact): any {
        return {
            id: domainSubjectContact.id,
            name: domainSubjectContact.name,
            created_at: domainSubjectContact.created_at,
            updated_at: domainSubjectContact.updated_at,
        }
    }


    toDomain(persistenceSubjectContact: any): ISubjectContact {
        return {
            id: persistenceSubjectContact.id,
            name: persistenceSubjectContact.name,
            created_at: persistenceSubjectContact.created_at,
            updated_at: persistenceSubjectContact.updated_at,
        }
    }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new SubjectContactMapper();